import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M24 13.2H0V10.8H24V13.2ZM24 6H0V8.4H24V6ZM16.8 15.6H0V18H16.8V15.6Z' />
        </SvgIcon>
    );
});
